import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ReactComponent as HotelIcon } from '../../../../src/res/Hotels/Kitchen Utensil.svg';
const HotelBookingReport = () => {
    const [bookingTransactions, setBookingTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBookingTransactions = async () => {
            try {
                const jwtToken = sessionStorage.getItem('jwtToken');
                if (!jwtToken) {
                    throw new Error("No JWT token found in sessionStorage.");
                }

                const response = await fetch('https://api.ipaisa.co.in/myapp/hotels/hotelbookingtransactions', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${jwtToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch data: ${response.statusText}`);
                }

                const data = await response.json();
                setBookingTransactions(data);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };

        fetchBookingTransactions();
    }, []);

    if (loading) {
        return <Typography>Loading...</Typography>;
    }

    if (error) {
        return <Typography color="error">Error: {error}</Typography>;
    }

    // Check if bookingTransactions is empty
    if (bookingTransactions.length === 0) {
        return <Typography>No booking data available.</Typography>;
    }

    return (
        <Box sx={{ padding: "20px", backgroundColor: "#f5f5f5", borderRadius: 2 }}>
            <Typography variant="h4" sx={{ marginBottom: 3, fontWeight: "bold", color: "#1976d2" }}>
                Hotel Booking Details
            </Typography>

            {bookingTransactions.map((bookingData, index) => (
                <Accordion key={index} sx={{ marginBottom: 3, borderRadius: 2, backgroundColor: "#fff" }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#1976d2" }} />}>
                        <Typography variant="h6" sx={{ fontWeight: "bold", display: "flex", alignItems: "center" }}>
                            <HotelIcon sx={{ marginRight: 1, color: "#1976d2" }} />
                            Booking {index + 1}: {bookingData.hotelName} ({bookingData.bookingId})
                        </Typography>
                    </AccordionSummary>

                    <AccordionDetails sx={{ backgroundColor: "#fafafa", borderRadius: 2, padding: 2 }}>
                        {/* Booking Overview */}
                        <Paper elevation={3} sx={{ padding: "20px", marginBottom: 3, borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#444" }}>
                                Booking Overview
                            </Typography>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        {[
                                            { label: "Booking ID", value: bookingData.bookingId },
                                            { label: "Confirmation No", value: bookingData.confirmationNo },
                                            { label: "Status", value: bookingData.hotelBookingStatus },
                                            { label: "Invoice Amount", value: `₹${bookingData.invoiceAmount}` },
                                            { label: "Check-In Date", value: new Date(bookingData.checkInDate).toLocaleString() },
                                            { label: "Check-Out Date", value: new Date(bookingData.checkOutDate).toLocaleString() },
                                            { label: "Hotel Name", value: bookingData.hotelName },
                                            { label: "Address", value: `${bookingData.addressLine1}, ${bookingData.city}` },
                                        ].map((item, idx) => (
                                            <TableRow key={idx} sx={{ backgroundColor: idx % 2 ? "#f9f9f9" : "white" }}>
                                                <TableCell sx={{ fontWeight: "bold" }}>{item.label}</TableCell>
                                                <TableCell>{item.value}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>

                        {/* Passenger Details */}
                        <Paper elevation={3} sx={{ padding: "20px", marginBottom: 3, borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#444" }}>
                                Passenger Details
                            </Typography>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        {JSON.parse(bookingData.responseData).GetBookingDetailResult.HotelRoomsDetails[0].HotelPassenger.map((passenger, idx) => (
                                            <TableRow key={idx} sx={{ backgroundColor: idx % 2 ? "#f9f9f9" : "white" }}>
                                                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                                                <TableCell>{passenger.FirstName} {passenger.LastName}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>

                        {/* Invoice Details */}
                        <Paper elevation={3} sx={{ padding: "20px", borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#444" }}>
                                Invoice Details
                            </Typography>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        {[
                                            { label: "Invoice No", value: bookingData.invoiceNo },
                                            { label: "Invoice Created On", value: new Date(bookingData.invoiceCreatedOn).toLocaleString() },
                                            { label: "Opening Balance", value: `₹${bookingData.openingBalance}` },
                                            { label: "Closing Balance", value: `₹${bookingData.closingBalance}` },
                                        ].map((item, idx) => (
                                            <TableRow key={idx} sx={{ backgroundColor: idx % 2 ? "#f9f9f9" : "white" }}>
                                                <TableCell sx={{ fontWeight: "bold" }}>{item.label}</TableCell>
                                                <TableCell>{item.value}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>

    );
};

export default HotelBookingReport;
